
<div class="webhook-variables-container">
    
    <div *ngIf="editMode" class="edit-panel">
        <div class="edit-panel-action">
            <button nz-button nzSize="small" nzType="primary" [nzLoading]="loadingAddButton" (click)="addRow()" class="search-button">{{'save'|translateTA}}</button>
            <button nz-button nzSize="small" (click)="clearRow()" class="search-button">{{'reset'|translateTA}}</button>
            <button nz-button nzSize="small" nzDanger (click)="editMode=false;clearRow();">{{'cancel'|translateTA}}</button>
        </div>
        <nz-divider *ngIf="INTERNALID== null || INTERNALID==''" nzText="{{'workflow.new.variable'|translateTA}}" nzOrientation="right"></nz-divider>
        <nz-divider *ngIf="INTERNALID!= null && INTERNALID!=''" nzText="{{'workflow.edit.variable'|translateTA:{internalid:INTERNALID} }}" nzOrientation="right"></nz-divider>
        <div class="edit-panel-container">
            <div class="edit-panel-container-left">
                <webhook-form-input [mainformGroup]="newRow"  [field]="nameField" ></webhook-form-input>
        
                <webhook-form-input [mainformGroup]="newRow"  [field]="descriptionField" ></webhook-form-input>
        
                <webhook-form-search [mainformGroup]="newRow"  [field]="codeCompanyField" ></webhook-form-search>
        
                <webhook-form-search [mainformGroup]="newRow"  [field]="codecontractField" ></webhook-form-search>
        
                <webhook-form-search [mainformGroup]="newRow"  [field]="codemktpField" ></webhook-form-search>
            </div>
            <nz-divider nzType="vertical"> </nz-divider>
            <div class="edit-panel-container-right">
                <webhook-form-textbox [mainformGroup]="newRow"  [rootForm]="newRow"  [field]="formulaField2" ></webhook-form-textbox>
            </div>
        </div>
        
    </div>
    <button nz-button nzType="primary" nzShape="circle" *ngIf="!editMode" (click)="editMode=true">
      <nz-icon nzType="plus" />
    </button>
    <nz-table #variableTable *ngIf="!editMode"
            [nzData]="variables" 
            [nzBordered]="true"   
            [nzScroll]="{ y: '240px' }" 
            nzSize="small" 
            nzShowSizeChanger
            [nzFrontPagination]="false"
            [nzLoading]="loading"
            [nzTotal]="total"
            [nzPageSize]="pageSize"
            [nzPageIndex]="pageIndex"
            [nzTableLayout]="'fixed'"
            (nzQueryParams)="onQueryParamsChange($event)"
            class="variable-table">
        <thead>

           
            <tr>
                <th  class="cell-normal" nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="NAME">{{'name'|translateTA}}
                    <nz-filter-trigger [(nzVisible)]="visible.NAME"  [nzActive]="variableTable.data.length > 0" [nzDropdownMenu]="menuName">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                <th  class="cell-normal" nzCustomFilter >{{'description'|translateTA}}
                    <nz-filter-trigger [(nzVisible)]="visible.DESCRIPTION"   [nzActive]="variableTable.data.length > 0" [nzDropdownMenu]="menuDescription">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                <th  class="cell-normal" nzCustomFilter >{{'formula'|translateTA}}
                    <nz-filter-trigger [(nzVisible)]="visible.TEXT"   [nzActive]="variableTable.data.length > 0" [nzDropdownMenu]="menuFormula">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                 
                <th  class="cell-normal" nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="CODECOMPANY">{{'codecompany'|translateTA}}
                    <nz-filter-trigger [(nzVisible)]="visible.CODECOMPANY" [nzActive]="variableTable.data.length > 0" [nzDropdownMenu]="menuCompany">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                <th  class="cell-normal" nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="CODECONTRACT">{{'codecontract'|translateTA}}
                     <nz-filter-trigger [(nzVisible)]="visible.CODECONTRACT"  [nzActive]="variableTable.data.length > 0" [nzDropdownMenu]="menuContract">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                <th class="cell-normal" nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="CODEMKTP">{{'codemktp'|translateTA}}
                     <nz-filter-trigger [(nzVisible)]="visible.CODEMKTP"  [nzActive]="variableTable.data.length > 0" [nzDropdownMenu]="menuMktp">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                <th  nzWidth="100px" >{{'actions'|translateTA}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let v of variableTable.data" (dblclick)="editVariableDoubleClick(v)">
                <td  class="cell-normal">{{ v.NAME }}</td>
                <td   class="cell-normal">{{ v.DESCRIPTION }}</td>
                <td   class="cell-normal">{{ v.TEXT }}</td>
                <td   class="cell-normal">{{ v.CODECOMPANY }} - {{v['FK_MKTPCONTRACTPREF_MKTPCOMPANIES->NAME']}}</td>
                <td   class="cell-normal">{{ v.CODECONTRACT }} - {{v['FK_MKTPCONTRACTPREF_MKTPCONTRACT->CONTRACTNAME']}}</td>
                <td   class="cell-normal">{{ v.CODEMKTP }} - {{v['FK_MKTPCONTRACTPREF_MKTPLACES->NAME']}}</td>
                <td>
                     <button nz-button nzType="primary" nzShape="circle"  (click)="editVariable(v)" class="search-button">
                        <nz-icon nzType="edit" />
                    </button>
                    <button nz-button nzType="primary" nzShape="circle" nzDanger (click)="deleteVariable(v)" [nzLoading]="loadingRemoveButton">
                        <nz-icon nzType="delete" />
                    </button>
                    
                </td>
            </tr>
        </tbody>
    </nz-table>
</div>

<nz-dropdown-menu #menuCompany="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-search [mainformGroup]="filterFormGroup"  [field]="codeCompanyField" ></webhook-form-search>
          <button nz-button nzSize="small" nzType="primary" (click)="search('CODECOMPANY')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('CODECOMPANY')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuContract="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-search [mainformGroup]="filterFormGroup"  [field]="codecontractField" ></webhook-form-search>
          <button nz-button nzSize="small" nzType="primary" (click)="search('CODECONTRACT')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('CODECONTRACT')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuMktp="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-search [mainformGroup]="filterFormGroup"  [field]="codemktpField" ></webhook-form-search>
          <button nz-button nzSize="small" nzType="primary" (click)="search('CODEMKTP')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('CODEMKTP')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuName="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-input [mainformGroup]="filterFormGroup"  [field]="nameField" ></webhook-form-input>
          <button nz-button nzSize="small" nzType="primary" (click)="search('NAME')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('NAME')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuFormula="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-input [mainformGroup]="filterFormGroup"  [field]="formulaField" ></webhook-form-input>
          <button nz-button nzSize="small" nzType="primary" (click)="search('TEXT')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('TEXT')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuDescription="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-input [mainformGroup]="filterFormGroup"  [field]="descriptionField" ></webhook-form-input>
          <button nz-button nzSize="small" nzType="primary" (click)="search('DESCRIPTION')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('DESCRIPTION')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>

